import { t } from 'i18next'
import { BadRequestResponse, EntityNotFoundResponse } from '../types/Errors'

export function mapRejectionReasonToTranslationString(reason: string | null | undefined) {
  if (reason == null) {
    return null
  }

  let translatedString
  switch (reason) {
    case 'NotBlank':
    case 'NotEmpty':
      translatedString = t('errors.notBlank')
      break
    case 'NotNull':
      translatedString = t('errors.notNull')
      break
    case 'Pattern':
      translatedString = t('errors.pattern')
      break
    case 'GuaranteeFormula':
      translatedString = t('errors.guaranteeFormula')
      break
    case 'Uppercase':
    case 'ClassifierExists':
    case 'InvalidValue':
      translatedString = t('errors.invalidClassifier')
      break
    case 'CommodityCode':
      translatedString = t('errors.codelist')
      break
    case 'ValidInputText':
      translatedString = t('errors.invalidInputText')
      break
    default:
      translatedString = ''
  }

  return translatedString
}

export function extractErrorMessageFromBadRequestReason({ reason }: BadRequestResponse) {
  return mapRejectionReasonToTranslationString(reason)
}

export function mapEntityToTranslatedString({ entity }: EntityNotFoundResponse) {
  if (entity === null || entity === undefined) {
    return null
  }
  const translatedString = ''

  if (entity === 'Declaration') {
    return t('entity.declaration')
  }
  if (entity === 'Customer') {
    return t('entity.customer')
  }
  if (entity === 'Restriction') {
    return t('entity.restriction')
  }

  return translatedString
}

export function hasMessage(e: unknown): e is { message: string } {
  return typeof e === 'object'
    && e !== null
    && 'message' in e
    && typeof (e as any).message === 'string'
}

// 2) Get a message if available; otherwise undefined
export function getErrorMessage(e: unknown): string | undefined {
  if (e instanceof Error) return e.message
  if (typeof e === 'string') return e
  if (hasMessage(e)) return e.message
  return undefined
}

